import { render } from "./eVisa.vue?vue&type=template&id=b7e4afa0&scoped=true"
import script from "./eVisa.vue?vue&type=script&lang=js"
export * from "./eVisa.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=b7e4afa0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e4afa0"]])

export default __exports__